export const ASCENDING = 'asc';
export const DESCENDING = 'desc';

type SortDirection = typeof ASCENDING | typeof DESCENDING;
export default SortDirection;
